import React, { useState } from 'react'
import { Card, Flex, Spinner } from '@Common/Components'
import { useWindowSize } from 'react-use'
import { Agency } from '../../Components/Agency'
import { useQuery } from '@tanstack/react-query'
import { fetchAgency } from './Functions'
import { getUrlParams } from '@Common/Services'
import { QuoteForm } from './QuoteForm'

const RequestQuote = () => {
  const { width: screenWidth, height: screenHeight } = useWindowSize()
  const agencyCode = getUrlParams('agency')
  const isInjected = getUrlParams('iframe') === 'true'
  const [formData, setFormData] = useState({})

  const { isSuccess, data: agency = {} } = useQuery(['agencyInfo', agencyCode], fetchAgency(agencyCode), { enabled: !!agencyCode })

  if (!isSuccess) return <Spinner />

  const cardHeight = Math.min(screenHeight * 0.95, 1000)

  return (screenHeight > 700 && screenWidth > 1000) && !isInjected
    ? (
      <Flex row fw style={{ minHeight: cardHeight, overflow: 'auto' }}>
        <Card style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', flexDirection: 'column', width: '28%', minHeight: cardHeight }}>
          <Agency agency={agency} />
        </Card>
        <div style={{ width: '4%' }} />
        <Card style={{ width: '62%', minHeight: cardHeight }}>
          <QuoteForm formData={[formData, setFormData]} />
        </Card>
      </Flex>)
    : (
      <div style={{ height: '100vh', width: 'calc(100% + 40px)', backgroundColor: 'rgba(255, 255, 255,0.1)', margin: -20 }}>
        <QuoteForm formData={[formData, setFormData]} />
      </div>)
}
export default RequestQuote
